export default "__VITE_ASSET__Bl5nmRsV__"